module.exports = __webpack_public_path__ + "static/media/listening_image4.b63e1a2a.webp";